import Vue from "vue";
import axios from "axios";
import moment from "moment";
import "../filters";

export default {
  name: "filterData",
  components: {
    filterIcon: require("./filterIcon.vue").default,
  },
  props: {
    isOffline: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "filter_alt",
    },
    filterTitle: {
      type: String,
      default: "filters",
    },
    title: {
      type: String,
      default: "Filter Data",
    },
    filters: {
      type: Array,
      required: true,
    },
    applyFilterFunc: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      selectedFilters: [],
      filterKeys: [],
      selectedKeys: [],
    };
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.filters = this.filters.sort((a, b) => a.index - b.index);

      for (var i = 0; i < this.filters.length; i++) {
        this.filterKeys.push({
          index: i,
          field: this.filters[i].field,
          desc: this.filters[i].fieldDesc,
        });

        if (this.filters[i].added) {
          this.filters[i].index = i;
          this.selectedFilters.push(this.filters[i]);
          this.selectedKeys.push(this.filters[i].field);
        }
      }
    },
    onKeyChange(event, index) {
      let newFilters = [];
      let newSelectedKeys = [];

      for (var i = 0; i < index; i++) {
        if (this.selectedFilters[i].field != event.target.value) {
          this.selectedFilters[i].index = newFilters.length;
          newFilters.push(this.selectedFilters[i]);
          newSelectedKeys.push(this.selectedFilters[i].field);
        }
      }

      if (newFilters.filter((a) => a.field == event.target.value).length == 0) {
        var fi = this.filters.filter((a) => a.field == event.target.value)[0];

        fi.value = fi.defaultValue;
        fi.added = true;
        fi.index = newFilters.length;
        newFilters.push(fi);
        newSelectedKeys.push(event.target.value);
      }

      for (var inx = index + 1; inx < this.selectedFilters.length; inx++) {
        if (this.selectedFilters[inx].field != event.target.value) {
          this.selectedFilters[inx].index = newFilters.length;
          newFilters.push(this.selectedFilters[inx]);
          newSelectedKeys.push(this.selectedFilters[inx].field);
        }
      }

      this.selectedFilters = newFilters; //.sort((a, b) => a.index - b.index);
      this.selectedKeys = newSelectedKeys;

      for (var f = 0; f < this.filters.length; f++) {
        if (
          this.selectedFilters.filter((a) => a.field == this.filters[f].field)
            .length == 0
        )
          this.filters[f].added = false;
        else this.filters[f].added = true;
      }

      this.selectedFilters = newFilters; //.sort((a, b) => a.index - b.index);
      this.selectedKeys = newSelectedKeys;
    },
    addNewFilter() {
      if (this.selectedFilters.filter((a) => a.field == "").length > 0) return;

      this.selectedFilters.push({
        index: this.selectedFilters.length,
        field: "",
        fieldDesc: "",
        type: "",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.selectedKeys.push("");

      this.selectedFilters = this.selectedFilters; //.sort((a, b) => a.index - b.index);
    },
    restFilters() {
      let newFilters = [];
      let newSelectedKeys = [];

      for (
        var i = 0;
        i < this.filters.filter((a) => a.addedDefault).length;
        i++
      ) {
        this.filters.filter((a) => a.addedDefault)[i].index = i;
        this.filters.filter((a) => a.addedDefault)[i].value =
          this.filters.filter((a) => a.addedDefault)[i].defaultValue;
        this.filters.filter((a) => a.addedDefault)[i].added =
          this.filters.filter((a) => a.addedDefault)[i].addedDefault;

        newFilters.push(this.filters.filter((a) => a.addedDefault)[i]);

        if (this.filters.filter((a) => a.addedDefault)[i].addedDefault)
          newSelectedKeys.push(
            this.filters.filter((a) => a.addedDefault)[i].field
          );
      }

      this.selectedKeys = newSelectedKeys;
      this.selectedFilters = newFilters; //.sort((a, b) => a.index - b.index);

      for (var i = 0; i < this.filters.length; i++) {
        if (
          this.selectedFilters.filter((a) => a.field == this.filters[i].field)
            .length == 0
        )
          this.filters[i].added = false;
        else this.filters[i].added = true;
      }
    },
    applyFilter() {
      this.applyFilterFunc();
    },
  },
};
